import React from 'react';

// Ornamental gold divider inspired by fantasy scrollwork
export default function Ornament({ className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      <div className="h-[1px] w-24 bg-gradient-to-r from-transparent to-[#e4b44e]/60" />
      <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#e4b44e]">
        <path d="M16 2 L20 10 L16 18 L12 10 Z" stroke="currentColor" strokeWidth="1" fill="none" />
        <circle cx="16" cy="10" r="1.6" fill="currentColor" />
        <path d="M2 10 L10 10 M22 10 L30 10" stroke="currentColor" strokeWidth="1" strokeLinecap="round" />
      </svg>
      <div className="h-[1px] w-24 bg-gradient-to-l from-transparent to-[#e4b44e]/60" />
    </div>
  );
}
